import StandardError from '../StandardError'

export default class DeletePendingOrderError extends StandardError {
  constructor() {
    super('This order cannot be deleted until any pending support tickets are resolved')
  }
}
